import { computed, ref, Ref, watch } from '@vue/composition-api';
interface PropMap<T> {
  [index: string]: T;
}

export default function useLocalProp<T> (propMap: PropMap<T>, emit: (event: string, ...args: any[]) => void): Ref<Readonly<T>> {
  const [[propName, propValue]] = Object.entries(propMap);
  const internalValue: Ref<T> = ref(propValue);
  watch(() => propValue, (val) => {
    internalValue.value = val;
  });
  return computed({
    get () {
      return internalValue.value;
    },
    set (val) {
      internalValue.value = val;
      emit(`update:${propName}`, val);
    },
  });
}
